import React from "react";
import { useIntl } from "react-intl";
import DrawingToolIcon from "../DrawingToolIcon";
import { DRAWING_MENU_TOOLS } from "../drawingToolLabels";
import "./DrawingToolList.sass";

const ICON_SIZE = 16;

/**
 * The All tab: the tools in one column (po-chart-visual-spec.md §7.1).
 *
 * @param {object} props
 * @param {(toolId: string) => void} props.onSelect
 */
const DrawingToolList = ({ onSelect }) => {
  const intl = useIntl();

  return (
    <ul className="drawing-tool-list">
      {DRAWING_MENU_TOOLS.map(({ id, labelId }) => (
        <li key={id}>
          <button type="button" className="drawing-tool-list__item" onClick={() => onSelect(id)}>
            <DrawingToolIcon toolId={id} size={ICON_SIZE} />
            <span className="drawing-tool-list__name">{intl.formatMessage({ id: labelId })}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};

export default DrawingToolList;
